import type { ModalProps } from 'antd';
import { StyledModal } from '@app/components/modal/Modal';
import useFlowActions from '@app/hooks/flows/useFlowActions';
import type { AIFlowListItem } from '@app/services/aiFlow.types';

export type DeleteFlowModalProps = ModalProps & {
    data: AIFlowListItem;
    onCancel: () => void;
};

export const DeleteFlowModal = ({ data, onCancel, ...props }: DeleteFlowModalProps) => {
    const { deleteFlow } = useFlowActions();

    return (
        <StyledModal
            title="Delete Flow?"
            mask={{ closable: false }}
            okText="Delete"
            {...props}
            confirmLoading={deleteFlow?.isPending}
            onCancel={onCancel}
            onOk={() => {
                deleteFlow.mutate(
                    { id: data.id },
                    {
                        onSuccess: () => {
                            onCancel();
                        },
                    }
                );
            }}>
            <p>{`Are you sure you want to remove "${data?.name}"?`}</p>
        </StyledModal>
    );
};

export default DeleteFlowModal;
